// src/pages/Pipeline/SiteVisit.jsx
import React, { useState } from "react";
import { Box, Paper, TextField, Typography, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../utils/api";

export default function SiteVisit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    scheduled_date: "",
    notes: ""
  });

  async function submit(e) {
    e.preventDefault();
    try {
      await api.post("/leads/site-visit", {
        lead_id: id,
        scheduled_date: form.scheduled_date,
        notes: form.notes
      });
      alert("Site visit scheduled!");
      navigate(`/leads/${id}`);
    } catch (err) {
      console.error(err);
      alert("Failed to schedule visit");
    }
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Schedule Site Visit</Typography>
      <Paper sx={{ p: 3, mt: 2 }}>
        <form onSubmit={submit}>
          <TextField
            type="datetime-local"
            fullWidth
            required
            sx={{ mb: 2 }}
            label="Scheduled Date"
            InputLabelProps={{ shrink: true }}
            value={form.scheduled_date}
            onChange={(e) => setForm({ ...form, scheduled_date: e.target.value })}
          />

          <TextField
            fullWidth multiline rows={3}
            label="Notes (optional)"
            sx={{ mb: 2 }}
            value={form.notes}
            onChange={(e) => setForm({ ...form, notes: e.target.value })}
          />

          <Button variant="contained" type="submit">Schedule Visit</Button>
          <Button sx={{ ml: 2 }} variant="outlined" onClick={() => navigate(-1)}>Back</Button>
        </form>
      </Paper>
    </Box>
  );
}
